import React, { useContext } from 'react'
import { Container } from './Styled'
import { SessionContext } from 'data/context';

export const User: React.FC = () => {
  const username = useContext(SessionContext).username;
  
  return (
    <Container>
      <span style={{textTransform: 'uppercase'}}>{username}</span>
      <div />
    </Container>
  )
}
